module.exports = __webpack_public_path__ + "img/logo-simworx.20cc115e.png";